import { render, staticRenderFns } from "./VListModal.vue?vue&type=template&id=1986369c&scoped=true"
import script from "./VListModal.vue?vue&type=script&lang=ts"
export * from "./VListModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1986369c",
  null
  
)

export default component.exports